import { useEffect, useState } from "react";
import { Grid, Paper, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Alert } from "@mui/material";
import PropTypes from 'prop-types';

import { ContentHeaderTabs, CustomTabPanel, HeaderTab } from "../../tabs/Tabs";
import { deleteProfileService, deleteProfilePage } from "../../../actions/profile";
import { Loading } from "../../common/Loading";
import AvisoCobro from "../../common/AvisoCobro";
import { isEmpty } from "../../common/helpers";
import TabService from "./TabService";
import TabPagina from "./TabPagina";

import { useSelector, useDispatch } from "react-redux";

const ListaContratacion = ({
  services, paginas = [], irA, loading, initialTab = 0, aviso = ""
}) => {
  const dispatch = useDispatch();
  const direcciones = useSelector(state => state.profile.profile.direcciones);
  const [value, setValue] = useState(initialTab);
  // Aviso que llega al volver de guardar una página (p. ej. cuántas invitaciones se enviaron); se puede cerrar
  const [avisoVisible, setAvisoVisible] = useState(aviso);
  const [borradores, setBorradores] = useState([]);
  const [servicios, setServicios] = useState([]);

  const [actionLoading, setActionLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedDelete, setSelectedDelete] = useState({ id: null, type: null }); // type: 'SERVICE' or 'PAGE'

  useEffect(() => {
    if (!loading && !actionLoading) {
      const borradores = services.filter(srv => srv.borrador === true);
      setBorradores(borradores);
      const activos = services.filter(srv => srv.borrador === false);
      setServicios(activos);
    }
  }, [services, loading, actionLoading]);

  const confirmarEliminar = (id, type) => {
    setSelectedDelete({ id, type });
    setOpenModal(true);
  };

  const ejecutarEliminacion = async () => {
    const { id, type } = selectedDelete;
    setOpenModal(false);
    setActionLoading(true);
    if (type === 'SERVICE') {
      await dispatch(deleteProfileService(id));
    } else {
      await dispatch(deleteProfilePage(id));
    }
    setActionLoading(false);
  };

  if (loading || actionLoading) {
    return <Loading />
  }

  return (
    <Grid size={12}>
      {avisoVisible && (
        <Alert severity="success" onClose={() => setAvisoVisible("")} sx={{ mb: 2, borderRadius: '12px' }}>
          {avisoVisible}
        </Alert>
      )}
      {/* Si todavía no puede recibir sus pagos, aquí se entera (antes, hasta tener dinero esperando) */}
      <AvisoCobro sx={{ mb: 2 }} />
      <Paper>
        <ContentHeaderTabs
          value={value}
          onChange={(_, newValue) => setValue(newValue)}
          aria-label="tabs perfil"
        >
          <HeaderTab sx={{ width: "50%" }} label="Servicios" />
          <HeaderTab sx={{ width: "50%" }} label="Página de servicios" />
        </ContentHeaderTabs>
      </Paper>
      <CustomTabPanel
        styles={{ paddingTop: 3 }}
        value={value}
        index={0}
      >
        {
          !isEmpty(borradores) && (
            <TabService
              services={borradores}
              direcciones={direcciones}
              title="Borradores"
              subtitle="Completa la información de su servicio para que pueda ser publicado"
              irA={irA}
              type="SERVICE"
              borrador={true}
              eliminar={(id) => confirmarEliminar(id, 'SERVICE')}
            />
          )
        }
        <TabService
          services={servicios}
          direcciones={direcciones}
          title="Tus servicios"
          subtitle="Tus servicios activos e inactivos"
          irA={irA}
          type="SERVICE"
          eliminar={(id) => confirmarEliminar(id, 'SERVICE')}
        />
      </CustomTabPanel>
      <CustomTabPanel
        styles={{ paddingTop: 3, paddingBottom: 3 }}
        value={value}
        index={1}
      >
        <TabPagina
          paginas={paginas}
          irA={irA}
          eliminar={(id) => confirmarEliminar(id, 'PAGE')}
        />
      </CustomTabPanel>

      {/* Modal de Confirmación */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>
          {"¿Confirmar eliminación?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" sx={{ color: 'text.primary' }}>
            {selectedDelete.type === 'SERVICE'
              ? "¿Estás seguro de que deseas eliminar este servicio? Si tiene historial de cotizaciones, se ocultará; de lo contrario, se borrará permanentemente."
              : "¿Estás seguro de que deseas eliminar esta página de servicios? Esta acción borrará permanentemente sus imágenes y la ocultará del público."}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ pb: 2, px: 3 }}>
          <Button onClick={() => setOpenModal(false)}>
            Cancelar
          </Button>
          <Button
            onClick={ejecutarEliminacion}
            variant="contained"
            color="error"
            autoFocus
            sx={{ borderRadius: '8px' }}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

ListaContratacion.propTypes = {
  irA: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  services: PropTypes.array.isRequired,
  aviso: PropTypes.string,
};

export default ListaContratacion;
